import { formatAuthorization } from '@/common/utils/format'
import { get, pick } from 'lodash-es'
const KEYS = ['authorizedPics', 'pics']
export function revert (data = {}) {
  const contractData = get(data, 'contractGlobal')
  let revertted = {}
  if (contractData) {
    revertted = pick(contractData, KEYS)
    revertted = formatAuthorization(revertted.authorizationInfo)
  }
  return revertted
}

export default {
  revert
}
